import { Link } from 'react-router';
import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
import R from 'ramda';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';

const NavLink = createClass({
  propTypes: {
    routeName: PropTypes.string,
    activeRoutes: PropTypes.array,
    className: PropTypes.string,
    filterResults: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,
    name: PropTypes.string,
    classes: PropTypes.string,
    searchInput: PropTypes.any,
    children: PropTypes.any,
    style: PropTypes.object,
    push: PropTypes.func,
    onClick: PropTypes.func,
  },

  onClick() {
    this.props.push(this.props.routeName);
    if (this.props.onClick) this.props.onClick();
    else this.filterResults();
  },

  isInternal(to) {
    // If it's a relative url such as '/path', 'path' and does not contain a protocol we can assume it is internal.
    if (to.indexOf('://') === -1) return true;

    const toLocation = this.parseTo(to);
    return window.location.hostname === toLocation.hostname;
  },

  parseTo(to) {
    const parser = document.createElement('a');
    parser.href = to;
    return parser;
  },

  filterResults() {
    const routeName = (() => {
      // Removes /connections/ from routename
      if (this.props.routeName.indexOf('connections')) return this.props.routeName.slice(13);
      return this.props.routeName;
    })();
    if (this.props.filterResults) this.props.filterResults(routeName);
  },
  render() {
    const {
      location,
      routeName,
      style = {},
      activeRoutes = [],
      // searchInput,
    } = this.props;
    const currentPath = (location || {}).pathname;
    const routeMatch = R.any(route => {
      return route && currentPath && currentPath.indexOf(route) === 0;
    }, activeRoutes);
    const classes = getClassNames('nav-link', this.props.classes, {
      active: routeMatch,
    });
    if (!routeName) {
      return (
        <div style={Object.assign({ cursor: 'pointer' }, style)} onClick={this.props.onClick} className={classes}>
          {this.props.children}
        </div>
      );
    }
    const isInternal = this.isInternal(routeName);
    if (isInternal) {
      return (
        <div
          style={Object.assign({ cursor: 'pointer' }, style)}
          onClick={this.onClick}
          className={classes}
        >
          {this.props.children}
        </div>
      );
    }
    return (
      <a
        href={routeName}
        style={style}
        className={classes}
        onClick={this.props.onClick}
        target="_blank"
      >
        {this.props.children}
      </a>
    );
    /* jshint ignore:end */
  },
});

const mapDispatchToProps = dispatch => ({
  push: (...args) => dispatch(pushAction(...args)),
});
export default connect(null, mapDispatchToProps)(NavLink);



// WEBPACK FOOTER //
// ./src/app/components/nav-link.jsx